import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { ArrowLeftIcon, ChevronDownIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { NotFound } from './NotFound';
import { posts } from '../data/postsClean';
import { PostBlock } from '../types/content';
export function BlogPost() {
  const {
    slug
  } = useParams();
  const post = posts.find(p => p.slug === slug);
  if (!post) return <NotFound data-id="element-310" data-mp="3fe39u664jynm" />;
  const recent = posts.filter(p => p.slug !== post.slug).slice(0, 4);
  return <>
      <section className="tis-hero !text-left" data-id="element-311" data-mp="36frh9ylp6qsj">
        <div className="bg" style={{
        backgroundImage: `url("${post.image}")`
      }} aria-hidden="true" data-id="element-312" data-mp="36gklosx6p47i" />
        <div className="max-w-[min(100%,1500px)]" data-id="element-313" data-mp="31i98q9bledl2">
          <Link to="/blog" className="inline-flex items-center gap-2 font-slab text-sm font-bold uppercase tracking-[0.2em] text-ink-muted hover:text-white" data-id="element-314" data-mp="14o4qny5pwxwl">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-315" data-mp="zq3618sn8qj0" />
            Blog
          </Link>
          <h1 className="mt-6 font-slab text-[clamp(2.4rem,4.2vw,7rem)] font-black uppercase leading-[0.92] text-white" data-id="element-316" data-mp="113r3m2l2kc36">{post.title}</h1>
          <p className="mt-5 font-script text-[clamp(1.1rem,.8vw+.7rem,1.8rem)] italic text-gold-2" data-id="element-317" data-mp="s4nhepqlvgkg">
            <time dateTime={post.date} data-id="element-318" data-mp="x373qr942udc">{format(parseISO(post.date), 'MMMM d, yyyy')}</time> · {post.category}
          </p>
        </div>
      </section>

      <div className="grid gap-[clamp(30px,4vw,120px)] px-6 pb-[clamp(60px,6vw,160px)] lg:grid-cols-[minmax(0,1fr)_minmax(260px,24vw)]" data-id="element-319" data-mp="1ktkxqnb9b3ak">
        <article className="max-w-[72ch] text-[clamp(1rem,.35vw+.85rem,1.35rem)]" data-id="element-320" data-mp="1b39k291rtfqh">
          {post.blocks.map((block, i) => <Block key={i} block={block} data-id="element-321" data-mp="1g1jg0lvbkkd5" data-mpi={i} />)}

          {post.faqs && post.faqs.length > 0 && <section className="mt-14 border-t border-ink-line pt-10" aria-labelledby="faq-heading" data-id="element-322" data-mp="23qvx07ww1wq0">
              <h2 id="faq-heading" className="font-slab text-4xl font-black uppercase" data-id="element-323" data-mp="28jp0ksgmez0i">
                FAQs
              </h2>
              <div className="mt-6 divide-y divide-ink-line border-y border-ink-line" data-id="element-324" data-mp="2idulbu0g8b0i">
                {post.faqs.map(faq => <details key={faq.q} className="group py-5" data-id="element-325" data-mp="28g6gucd1jp55">
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-slab text-xl font-extrabold tracking-wide text-white" data-id="element-326" data-mp="28elnur6dke9e">
                      {faq.q}
                      <ChevronDownIcon className="h-4 w-4 shrink-0 text-neon transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-327" data-mp="1zh2w73y871oj" />
                    </summary>
                    <p className="mt-3 leading-relaxed text-ink-muted" data-id="element-328" data-mp="1pqgkhktmqvb4">{faq.a}</p>
                  </details>)}
              </div>
            </section>}

          <div className="tis-card mt-14 p-8" data-id="element-329" data-mp="1fqprxoomqqdo">
            <span className="tis-eyebrow" data-id="element-330" data-mp="1ftlp3asnlb12">Ready for your next tattoo?</span>
            <p className="mt-2 leading-relaxed text-ink-muted" data-id="element-331" data-mp="1bqz4nuybasdw">Book a full day with your favorite artist. Tell us your idea and we will confirm your artist and date.</p>
            <Button to="/book-now" className="mt-6" data-id="element-332" data-mp="3re324shsc0da">
              Book your full day
            </Button>
          </div>
        </article>

        <aside className="lg:sticky lg:top-28 lg:h-fit" data-id="element-333" data-mp="6qhg3hp14sm">
          <h2 className="font-slab text-xl font-extrabold uppercase tracking-[0.2em] text-gold-2" data-id="element-334" data-mp="56v0a062qbm0">Recent posts</h2>
          <ul className="mt-5 divide-y divide-ink-line border-y border-ink-line" data-id="element-335" data-mp="33quzkibqr5ey">
            {recent.map(p => <li key={p.slug} className="py-4" data-id="element-336" data-mp="38owi925992pw">
                <Link to={`/blog/${p.slug}`} className="group block" data-id="element-337" data-mp="3dn7shdzgpf8n">
                  <span className="block font-slab text-lg font-extrabold leading-snug text-white group-hover:text-neon-2" data-id="element-338" data-mp="3iefye01l2ih2">{p.title}</span>
                  <time dateTime={p.date} className="mt-1 block font-script text-sm italic text-ink-muted" data-id="element-339" data-mp="2ky0s09gg6fkr">
                    {format(parseISO(p.date), 'MMMM d, yyyy')}
                  </time>
                </Link>
              </li>)}
          </ul>
        </aside>
      </div>
    </>;
}
function Block({
  block
}: {
  block: PostBlock;
}) {
  switch (block.type) {
    case 'h2':
      return <h2 className="mb-4 mt-12 font-slab text-[clamp(1.8rem,1.6vw+1rem,3rem)] font-black uppercase leading-[0.95] text-white" data-id="element-340" data-mp="158rq2vimt15t">{block.text}</h2>;
    case 'h3':
      return <h3 className="mb-3 mt-8 font-slab text-[clamp(1.3rem,.8vw+.9rem,2rem)] font-extrabold tracking-wide text-gold-2" data-id="element-341" data-mp="1f5npmbqjycy8">{block.text}</h3>;
    case 'ul':
      return <ul className="my-6 list-disc space-y-2 pl-6 leading-relaxed text-ink-muted marker:text-neon" data-id="element-342" data-mp="1a8xcnxa1nxh1">
          {block.items.map(item => <li key={item} data-id="element-343" data-mp="1j6zgslp2r68j">{item}</li>)}
        </ul>;
    default:
      return <p className="mb-5 leading-relaxed text-ink-muted" data-id="element-344" data-mp="3pxpc25h4h3bx">{block.text}</p>;
  }
}